import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateModule } from "@ngx-translate/core";
import { DialogErrorComponent } from "./dialog-error.component";
import { MatDialogModule } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations:[
    DialogErrorComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    TranslateModule.forChild()
  ],
  exports: [
    DialogErrorComponent
  ]
})
export class DialogErrorModule {}
